module.exports = __webpack_public_path__ + "img/bmw2.8a3806de.png";